var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"introduce-page"},[_c('div',{ref:"contentBScrollWrap",staticClass:"content-wrap"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"btn",on:{"click":function($event){return _vm.$router.push('home')}}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }